import * as telemetryStatsActionTypes from 'single-asset/actions/telemetryStatsActionTypes';

export const defaultState = {
  isPending: false,
  wellStatList: [],
  failedResultList: [],
};

const wellStatsReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case telemetryStatsActionTypes.GASLIFT_WELL_STATS__FETCH_STATS_LIST: {
      return {
        ...defaultState,
        isPending: true,
      };
    }

    case telemetryStatsActionTypes.GASLIFT_WELL_STATS__FETCH_STATS_LIST_FAILED: {
      const { failedResultList } = action;

      return {
        ...defaultState,
        failedResultList,
      };
    }

    case telemetryStatsActionTypes.GASLIFT_WELL_STATS__FETCH_STATS_LIST_SUCCEEDED: {
      return {
        ...defaultState,
        wellStatList: action.successfulResultList,
      };
    }

    default: {
      return state;
    }
  }
};

export default wellStatsReducer;
